import { ActionService } from 'dashboard-services/services';

export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_PYTHON_EDITOR'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const CLEAR = 'CLEAR_VALUE_PYTHON_EDITOR'
  const clear = ActionService.makeActionCreator(CLEAR)

  return {
    changeValue,
    CHANGE_VALUE,
    clear,
    CLEAR
  }
})()